// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TikTok Connection Component Styles */
/* Tabbed layout: Publishing (Login Kit) + Business API */

.tiktok-connection {
    background: var(--card-bg, #fff);
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.tiktok-connection.loading {
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: center;
    padding: 40px;
    color: var(--text-secondary, #666);
}

.tiktok-connection .section-header {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 20px;
}

.tiktok-connection .header-icon {
    font-size: 2.5rem;
    line-height: 1;
}

.tiktok-connection .header-text h2 {
    margin: 0 0 8px 0;
    font-size: 1.5rem;
    color: var(--text-primary, #1a1a1a);
}

.tiktok-connection .header-text .description {
    margin: 0;
    color: var(--text-secondary, #666);
    font-size: 0.95rem;
}

/* Alerts */
.tiktok-connection .alert {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 16px;
    font-size: 0.9rem;
}

.tiktok-connection .alert-success {
    background: #f0fdf4;
    color: #166534;
    border: 1px solid #bbf7d0;
}

.tiktok-connection .alert-error {
    background: #fef2f2;
    color: #991b1b;
    border: 1px solid #fecaca;
}

.tiktok-connection .alert .dismiss {
    margin-left: auto;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.2rem;
    color: inherit;
    opacity: 0.6;
}

.tiktok-connection .alert .dismiss:hover {
    opacity: 1;
}

/* Account Card (shared profile info) */
.tiktok-connection .account-card {
    border: 1px solid var(--border-color, #e5e7eb);
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 16px;
}

.tiktok-connection .account-info {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.tiktok-connection .profile-picture {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}

.tiktok-connection .profile-picture.placeholder {
    background: linear-gradient(135deg, #25f4ee, #fe2c55);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
}

.tiktok-connection .account-details {
    flex: 1 1;
}

.tiktok-connection .account-details h3 {
    margin: 0 0 4px 0;
    font-size: 1.2rem;
    color: var(--text-primary, #1a1a1a);
}

.tiktok-connection .stats {
    display: flex;
    gap: 16px;
    margin: 8px 0;
    flex-wrap: wrap;
}

.tiktok-connection .stat {
    font-size: 0.85rem;
    color: var(--text-secondary, #666);
}

.tiktok-connection .stat strong {
    color: var(--text-primary, #1a1a1a);
}

.tiktok-connection .connected-date,
.tiktok-connection .last-post {
    margin: 4px 0 0;
    font-size: 0.8rem;
    color: var(--text-tertiary, #999);
}

/* Connection badges (mini status indicators) */
.tiktok-connection .connection-badges {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex-shrink: 0;
}

.tiktok-connection .mini-badge {
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 0.72rem;
    font-weight: 600;
    white-space: nowrap;
}

.tiktok-connection .mini-badge.active {
    background: #dcfce7;
    color: #166534;
}

.tiktok-connection .mini-badge.expired {
    background: #fef3c7;
    color: #92400e;
}

.tiktok-connection .mini-badge.none {
    background: #f3f4f6;
    color: #9ca3af;
}

/* ═══ Tabs ═══ */
.tiktok-tabs {
    display: flex;
    border-bottom: 2px solid var(--border-color, #e5e7eb);
    margin-bottom: 16px;
    gap: 4px;
}

.tiktok-tab {
    padding: 10px 20px;
    border: none;
    background: none;
    font-size: 0.9rem;
    font-weight: 500;
    color: var(--text-secondary, #666);
    cursor: pointer;
    border-bottom: 2px solid transparent;
    margin-bottom: -2px;
    transition: color 0.2s, border-color 0.2s;
}

.tiktok-tab:hover {
    color: var(--text-primary, #1a1a1a);
}

.tiktok-tab.active {
    color: #fe2c55;
    border-bottom-color: #fe2c55;
    font-weight: 600;
}

/* ═══ Tab Content ═══ */
.tiktok-tab-content {
    min-height: 120px;
}

.tiktok-tab-content .tab-panel {
    animation: fadeIn 0.2s ease-in;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(4px); }
    to { opacity: 1; transform: translateY(0); }
}

.tiktok-tab-content .tab-description {
    margin: 0 0 16px;
    font-size: 0.9rem;
    color: var(--text-secondary, #666);
}

/* Connection status inside tab */
.tiktok-connection .connection-status {
    padding: 16px;
    border: 1px solid var(--border-color, #e5e7eb);
    border-radius: 10px;
    background: var(--card-bg, #fafafa);
}

.tiktok-connection .status-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
    font-weight: 500;
    margin-bottom: 8px;
}

.tiktok-connection .status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
}

.tiktok-connection .status-indicator.connected .status-dot {
    background: #22c55e;
    box-shadow: 0 0 4px rgba(34, 197, 94, 0.4);
}

.tiktok-connection .status-indicator.expired .status-dot {
    background: #f59e0b;
    box-shadow: 0 0 4px rgba(245, 158, 11, 0.4);
}

.tiktok-connection .token-expiry,
.tiktok-connection .token-type {
    margin: 4px 0;
    font-size: 0.8rem;
    color: var(--text-tertiary, #999);
}

.tiktok-connection .tab-actions {
    display: flex;
    gap: 10px;
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px solid var(--border-color, #e5e7eb);
    flex-wrap: wrap;
}

/* Connect section inside tab (when not connected) */
.tiktok-connection .connect-section {
    text-align: center;
    padding: 16px 0;
}

.tiktok-connection .connect-prompt-small p {
    margin: 0 0 12px;
    color: var(--text-secondary, #666);
    font-size: 0.9rem;
}

.tiktok-connection .requirements {
    text-align: left;
    max-width: 400px;
    margin: 0 auto 16px;
    padding-left: 20px;
    color: var(--text-secondary, #666);
    font-size: 0.85rem;
}

.tiktok-connection .requirements li {
    margin-bottom: 6px;
}

/* Button variants */
.tiktok-connect-btn {
    background: linear-gradient(135deg, #25f4ee, #fe2c55) !important;
    color: #fff !important;
    border: none !important;
    font-weight: 600;
}

.tiktok-connect-btn:hover:not(:disabled) {
    opacity: 0.9;
}

.btn-outline {
    background: transparent;
    border: 1px solid var(--border-color, #d1d5db);
    color: var(--text-primary, #374151);
    border-radius: 6px;
    padding: 6px 14px;
    cursor: pointer;
    font-size: 0.85rem;
}

.btn-outline:hover:not(:disabled) {
    background: var(--hover-bg, #f9fafb);
}

.btn-danger-outline {
    background: transparent;
    border: 1px solid #fca5a5;
    color: #dc2626;
    border-radius: 6px;
    padding: 6px 14px;
    cursor: pointer;
    font-size: 0.85rem;
}

.btn-danger-outline:hover:not(:disabled) {
    background: #fef2f2;
}

/* Global disconnect actions */
.tiktok-connection .global-actions {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid var(--border-color, #e5e7eb);
    display: flex;
    justify-content: flex-end;
}

.btn-small {
    font-size: 0.8rem;
    padding: 4px 12px;
}

/* Responsive */
@media (max-width: 768px) {
    .tiktok-connection .account-info {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .tiktok-connection .stats {
        justify-content: center;
    }

    .tiktok-connection .tab-actions {
        flex-direction: column;
    }

    .tiktok-connection .connection-badges {
        flex-direction: row;
    }

    .tiktok-tabs {
        overflow-x: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/TikTokConnection.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC,yDAAyD;;AAEzD;IACI,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,SAAS;IACT,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA,uCAAuC;AACvC;IACI,8CAA8C;IAC9C,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,qDAAqD;IACrD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA,+CAA+C;AAC/C;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,qDAAqD;IACrD,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,oCAAoC;IACpC,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA,iCAAiC;AACjC;IACI,aAAa;IACb,8CAA8C;IAC9C,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;;IAEI,aAAa;IACb,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,kDAAkD;IAClD,eAAe;AACnB;;AAEA,oDAAoD;AACpD;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;IACI,gEAAgE;IAChE,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,8CAA8C;IAC9C,mCAAmC;IACnC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,8BAA8B;AAC9B;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kDAAkD;IAClD,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,eAAe;AACf;IACI;QACI,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["/* TikTok Connection Component Styles */\n/* Tabbed layout: Publishing (Login Kit) + Business API */\n\n.tiktok-connection {\n    background: var(--card-bg, #fff);\n    border-radius: 12px;\n    padding: 24px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.tiktok-connection.loading {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    justify-content: center;\n    padding: 40px;\n    color: var(--text-secondary, #666);\n}\n\n.tiktok-connection .section-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    margin-bottom: 20px;\n}\n\n.tiktok-connection .header-icon {\n    font-size: 2.5rem;\n    line-height: 1;\n}\n\n.tiktok-connection .header-text h2 {\n    margin: 0 0 8px 0;\n    font-size: 1.5rem;\n    color: var(--text-primary, #1a1a1a);\n}\n\n.tiktok-connection .header-text .description {\n    margin: 0;\n    color: var(--text-secondary, #666);\n    font-size: 0.95rem;\n}\n\n/* Alerts */\n.tiktok-connection .alert {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 16px;\n    border-radius: 8px;\n    margin-bottom: 16px;\n    font-size: 0.9rem;\n}\n\n.tiktok-connection .alert-success {\n    background: #f0fdf4;\n    color: #166534;\n    border: 1px solid #bbf7d0;\n}\n\n.tiktok-connection .alert-error {\n    background: #fef2f2;\n    color: #991b1b;\n    border: 1px solid #fecaca;\n}\n\n.tiktok-connection .alert .dismiss {\n    margin-left: auto;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 1.2rem;\n    color: inherit;\n    opacity: 0.6;\n}\n\n.tiktok-connection .alert .dismiss:hover {\n    opacity: 1;\n}\n\n/* Account Card (shared profile info) */\n.tiktok-connection .account-card {\n    border: 1px solid var(--border-color, #e5e7eb);\n    border-radius: 10px;\n    padding: 20px;\n    margin-bottom: 16px;\n}\n\n.tiktok-connection .account-info {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n}\n\n.tiktok-connection .profile-picture {\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    object-fit: cover;\n    flex-shrink: 0;\n}\n\n.tiktok-connection .profile-picture.placeholder {\n    background: linear-gradient(135deg, #25f4ee, #fe2c55);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.5rem;\n}\n\n.tiktok-connection .account-details {\n    flex: 1;\n}\n\n.tiktok-connection .account-details h3 {\n    margin: 0 0 4px 0;\n    font-size: 1.2rem;\n    color: var(--text-primary, #1a1a1a);\n}\n\n.tiktok-connection .stats {\n    display: flex;\n    gap: 16px;\n    margin: 8px 0;\n    flex-wrap: wrap;\n}\n\n.tiktok-connection .stat {\n    font-size: 0.85rem;\n    color: var(--text-secondary, #666);\n}\n\n.tiktok-connection .stat strong {\n    color: var(--text-primary, #1a1a1a);\n}\n\n.tiktok-connection .connected-date,\n.tiktok-connection .last-post {\n    margin: 4px 0 0;\n    font-size: 0.8rem;\n    color: var(--text-tertiary, #999);\n}\n\n/* Connection badges (mini status indicators) */\n.tiktok-connection .connection-badges {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    flex-shrink: 0;\n}\n\n.tiktok-connection .mini-badge {\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-size: 0.72rem;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.tiktok-connection .mini-badge.active {\n    background: #dcfce7;\n    color: #166534;\n}\n\n.tiktok-connection .mini-badge.expired {\n    background: #fef3c7;\n    color: #92400e;\n}\n\n.tiktok-connection .mini-badge.none {\n    background: #f3f4f6;\n    color: #9ca3af;\n}\n\n/* ═══ Tabs ═══ */\n.tiktok-tabs {\n    display: flex;\n    border-bottom: 2px solid var(--border-color, #e5e7eb);\n    margin-bottom: 16px;\n    gap: 4px;\n}\n\n.tiktok-tab {\n    padding: 10px 20px;\n    border: none;\n    background: none;\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: var(--text-secondary, #666);\n    cursor: pointer;\n    border-bottom: 2px solid transparent;\n    margin-bottom: -2px;\n    transition: color 0.2s, border-color 0.2s;\n}\n\n.tiktok-tab:hover {\n    color: var(--text-primary, #1a1a1a);\n}\n\n.tiktok-tab.active {\n    color: #fe2c55;\n    border-bottom-color: #fe2c55;\n    font-weight: 600;\n}\n\n/* ═══ Tab Content ═══ */\n.tiktok-tab-content {\n    min-height: 120px;\n}\n\n.tiktok-tab-content .tab-panel {\n    animation: fadeIn 0.2s ease-in;\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(4px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.tiktok-tab-content .tab-description {\n    margin: 0 0 16px;\n    font-size: 0.9rem;\n    color: var(--text-secondary, #666);\n}\n\n/* Connection status inside tab */\n.tiktok-connection .connection-status {\n    padding: 16px;\n    border: 1px solid var(--border-color, #e5e7eb);\n    border-radius: 10px;\n    background: var(--card-bg, #fafafa);\n}\n\n.tiktok-connection .status-indicator {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    margin-bottom: 8px;\n}\n\n.tiktok-connection .status-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.tiktok-connection .status-indicator.connected .status-dot {\n    background: #22c55e;\n    box-shadow: 0 0 4px rgba(34, 197, 94, 0.4);\n}\n\n.tiktok-connection .status-indicator.expired .status-dot {\n    background: #f59e0b;\n    box-shadow: 0 0 4px rgba(245, 158, 11, 0.4);\n}\n\n.tiktok-connection .token-expiry,\n.tiktok-connection .token-type {\n    margin: 4px 0;\n    font-size: 0.8rem;\n    color: var(--text-tertiary, #999);\n}\n\n.tiktok-connection .tab-actions {\n    display: flex;\n    gap: 10px;\n    margin-top: 14px;\n    padding-top: 14px;\n    border-top: 1px solid var(--border-color, #e5e7eb);\n    flex-wrap: wrap;\n}\n\n/* Connect section inside tab (when not connected) */\n.tiktok-connection .connect-section {\n    text-align: center;\n    padding: 16px 0;\n}\n\n.tiktok-connection .connect-prompt-small p {\n    margin: 0 0 12px;\n    color: var(--text-secondary, #666);\n    font-size: 0.9rem;\n}\n\n.tiktok-connection .requirements {\n    text-align: left;\n    max-width: 400px;\n    margin: 0 auto 16px;\n    padding-left: 20px;\n    color: var(--text-secondary, #666);\n    font-size: 0.85rem;\n}\n\n.tiktok-connection .requirements li {\n    margin-bottom: 6px;\n}\n\n/* Button variants */\n.tiktok-connect-btn {\n    background: linear-gradient(135deg, #25f4ee, #fe2c55) !important;\n    color: #fff !important;\n    border: none !important;\n    font-weight: 600;\n}\n\n.tiktok-connect-btn:hover:not(:disabled) {\n    opacity: 0.9;\n}\n\n.btn-outline {\n    background: transparent;\n    border: 1px solid var(--border-color, #d1d5db);\n    color: var(--text-primary, #374151);\n    border-radius: 6px;\n    padding: 6px 14px;\n    cursor: pointer;\n    font-size: 0.85rem;\n}\n\n.btn-outline:hover:not(:disabled) {\n    background: var(--hover-bg, #f9fafb);\n}\n\n.btn-danger-outline {\n    background: transparent;\n    border: 1px solid #fca5a5;\n    color: #dc2626;\n    border-radius: 6px;\n    padding: 6px 14px;\n    cursor: pointer;\n    font-size: 0.85rem;\n}\n\n.btn-danger-outline:hover:not(:disabled) {\n    background: #fef2f2;\n}\n\n/* Global disconnect actions */\n.tiktok-connection .global-actions {\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid var(--border-color, #e5e7eb);\n    display: flex;\n    justify-content: flex-end;\n}\n\n.btn-small {\n    font-size: 0.8rem;\n    padding: 4px 12px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .tiktok-connection .account-info {\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n    }\n\n    .tiktok-connection .stats {\n        justify-content: center;\n    }\n\n    .tiktok-connection .tab-actions {\n        flex-direction: column;\n    }\n\n    .tiktok-connection .connection-badges {\n        flex-direction: row;\n    }\n\n    .tiktok-tabs {\n        overflow-x: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
